const handleImgSrcError = (e: any) => {
  const { target } = e;
  target.onerror = null;
  target.src = `${process.env.PUBLIC_URL}/default_avatar.jpeg`;
};

export default handleImgSrcError;
